import { PlusOneOutlined } from '@material-ui/icons';
import { Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CButton from 'src/component/Button';
import Modal from 'src/component/Modal/Modal';
import { uploadBanner } from 'src/services/napi';

const ALLOWED_FILE_MIME_TYPES = [
  'application/pdf',
  'application/xml',
  'application/vnd.google-earth.kml+xml',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/zip',
  'application/x-rar-compressed',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.rar'
];

const ALLOWED_FILE_EXTENSIONS = ['png', 'kml', 'xls', 'xlsx', 'docx', 'doc', 'zip', 'rar'];

const FileElement = ({ index, value, onChange = () => {}, onSelectExisting }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [uploaded, setUploaded] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  function selectExisting(onClick) {
    return (
      <CButton onClick={onClick} size="large" type="edit">
        Select Existing
      </CButton>
    );
  }

  useEffect(() => {
    if (value) {
      setFileList([
        {
          name: 'Preview',
          status: 'done',
          uid: index,
          url: value || ''
        }
      ]);
    }
  }, [value, index]);

  const projectId = useSelector(({ project }) => project.currentProject._id);

  const uploadButton = (
    <div>
      <PlusOneOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const handleChange = ({ fileList }) => {
    setFileList(fileList);

    if (!fileList.length) {
      onChange('');
    }
    setFileList([]);
  };

  const uploadRequest = async (data) => {
    const formData = new FormData();
    formData.append('file', data.file);

    const res = await uploadBanner(formData, projectId);

    onChange(res.data.file.url);

    data.onSuccess();
  };

  const customRequest = async (data) => {
    setUploaded(data);
    uploadRequest(data);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        paddingLeft: '35px'
      }}
    >
      <Upload
        beforeUpload={(file) => {
          const fileExtension = file.name.includes('.') ? file.name.split('.').pop() : '';

          const isFileAllowed =
            ALLOWED_FILE_MIME_TYPES.includes(file.type) ||
            ALLOWED_FILE_EXTENSIONS.includes(fileExtension);

          if (!isFileAllowed) {
            console.error(
              `${file.name} has unsupported file type ${file.type} and extension ${fileExtension}`
            );
          }

          return isFileAllowed || Upload.LIST_IGNORE;
        }}
        customRequest={customRequest}
        fileList={fileList}
        listType="picture-card"
        onChange={handleChange}
        onPreview={handlePreview}
      >
        {uploadButton}
      </Upload>
      <Modal
        footerActions={
          <>
            <CButton size="large" type="secondary">
              Delete
            </CButton>
            <CButton
              onClick={() => {
                uploadRequest(uploaded);
              }}
              size="large"
              type="primary"
            >
              Add
            </CButton>
          </>
        }
        handleClose={() => setIsOpen(false)}
        isModalOpen={isOpen}
        styles={{
          '& .MuiDialogActions-root': {
            justifyContent: 'center',
            paddingBottom: '24px'
          },
          '& .modal-title': {
            fontSize: '16px',
            fontWeight: 500
          }
        }}
        titleContent={<h2 className="modal-title">Aspect Ratio does not match</h2>}
      >
        <p
          style={{
            fontSize: '24px',
            fontWeight: 700
          }}
        >
          Delete uploaded image or Add?
        </p>
      </Modal>
      <div className="upload-div">{selectExisting(onSelectExisting())}</div>
      <Modal
        handleClose={handleCancel}
        isModalOpen={previewVisible}
        styles={{
          '& .MuiDialogContent-root': {
            paddingBottom: '24px',
            paddingTop: '0px'
          }
        }}
        titleContent={<h3 className="modal-title">{previewTitle}</h3>}
      >
        {['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].some((ext) => previewImage.endsWith(ext)) ? (
          <img alt="example" src={previewImage} style={{ width: '100%' }} />
        ) : (
          <a href={previewImage} rel="noopener noreferrer" target="_blank">
            Preview not possible, Open file
          </a>
        )}
      </Modal>
    </div>
  );
};

export default FileElement;
